// extracted by mini-css-extract-plugin
export var chevron = "_kh-2";
export var dropdownItems = "_kh-0";
export var item = "_kh-1";